import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import '../login.css';

export default function Login() {
  const [usuarioNombre, setUsuarioNombre] = useState('');
  const [contrasena, setContrasena] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');

    if (!usuarioNombre || !contrasena) {
      setError('Todos los campos son obligatorios');
      return;
    }

    try {
      const response = await axios.post('https://api-rci-g5ebbhava3anbgfy.centralus-01.azurewebsites.net/login', {
        // ✅ OJO: en tu API te está pidiendo "Nombre"
        Nombre: usuarioNombre,
        Contrasena: contrasena,
        MantenerSesion: true,
      });

      localStorage.setItem('token', response.data.token);
      navigate('/dashboard');
    } catch (err) {
      console.log('LOGIN ERROR:', err.response?.data || err.message);

      // Si el backend manda el error de validación, lo mostramos
      const msg =
        err.response?.data?.errors?.Nombre?.[0] ||
        err.response?.data?.title ||
        'Error en el servidor';

      setError(msg);
    }
  };

  return (
    <div className="login-container">
      <form className="login-box" onSubmit={handleLogin}>
        <h2>Iniciar Sesión</h2>

        <div className="input-group">
          <input
            type="text"
            placeholder="Usuario"
            value={usuarioNombre}
            onChange={(e) => {
              setUsuarioNombre(e.target.value);
              if (error) setError('');
            }}
          />
          {!usuarioNombre && error && <span className="error-icon">❗</span>}
          {!usuarioNombre && error && (
            <div className="error">El campo no puede estar vacío</div>
          )}
        </div>

        <div className="input-group">
          <input
            type="password"
            placeholder="Password"
            value={contrasena}
            onChange={(e) => {
              setContrasena(e.target.value);
              if (error) setError('');
            }}
          />
          {!contrasena && error && <span className="error-icon">❗</span>}
          {!contrasena && error && (
            <div className="error">El campo no puede estar vacío</div>
          )}
        </div>

        {usuarioNombre && contrasena && error && <div className="error">{error}</div>}

        <button type="submit">Ingresar</button>
      </form>
    </div>
  );
}